import HeaderLayout from '../../../components/Layout/Header/HeaderLayout';
import BodyRechargeWallet from '../../../components/wallet/BodyRechargeWallet';

const WalletRecharge = () => {
  const fileAs = {
    currency: 'pesos',
    fileAs: 'file as',
    fileAsComplete: 'file as complete',
    risk: 'agresivo',
    profit: '10',
  };

  return (
    <>
      <HeaderLayout fileAs={fileAs} />
      <BodyRechargeWallet />
    </>
  );
};

export default WalletRecharge;
